export default __webpack_public_path__ + "static/media/sd-event2.fabfd8c5.png";